import classNames from "classnames";
import React, { ReactNode } from "react";
import { ListDivider } from "./list-divider";
import { ListItem } from "./list-item";

type ListProps = {
    header?: ReactNode;
    compact?: boolean;
    small?: boolean;
    className?: string;
    variant?: "" | "text" | "button" | "menu";
    caretPosition?: "none" | "start" | "end";
    children?: any;
    [x: string]: any;
};

export const List = ({ header, compact, small, className, variant, caretPosition, children, ...props }: ListProps) => {
    const cn = classNames("bd-list", className, {
        "bd-compact": compact,
        "size-sm": small,
    });

    const MapChildren = (children: React.ReactNode) =>
        React.Children.map(children, (child) => {
            if (!React.isValidElement(child)) return child;
            var x: any = child;
            if (x?.type === ListDivider) return <li className="bd-list-divider"></li>;
            if (x?.type === List || x?.type === ListItem) {
                let newProps = { variant, compact, caretPosition, ...child.props, children: MapChildren(child.props?.children) };
                return React.cloneElement(child, newProps);
            }

            return !child.props?.children
                ? child
                : React.cloneElement(child, { ...child.props, children: MapChildren(child.props.children) });
            //return React.cloneElement(child, { children: MapChildren(child.props?.children) });
            return child;
        });

    return (
        <ul className={cn} {...props}>
            {header && <li className="bd-list-header">{header}</li>}
            {MapChildren(children)}
        </ul>
    );
};
